export class ObjectUtils {

  public static flat(obj: Object): Object {
    let result = {};

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
          const flattened = this.flat(obj[key]);
          result = { ...result, ...flattened };
        } else {
          result[key] = obj[key];
        }
      }
    }

    return result;
  }

  public static getObjectValue<T>(object: T, key: keyof T | string): any {
    let val = {...object};

    if (key) {
      (key as string).split('.').forEach(x => val = val?.[x]);
    } else {
      val = '' as T;
    }

    return val;
  }
}
